import { Box } from "@mui/material";
import config from "./../../config/config";
import { PROFILE_PRICE_IN_MAFIA } from "./../../constants/const";
import { toUSDFormat } from "./../../utils/utils";
import Logo from "./../Logo";
import useStyles from "./index.styles";

interface CostInformationProps {
  mafiaPrice: number;
}

export const CostInformation = ({ mafiaPrice }: CostInformationProps) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.createCostInfo}>
      <Box>Account registration costs:</Box>
      <Box className={classes.createCostToken}>
        <Logo />
        <Box>
          {toUSDFormat(PROFILE_PRICE_IN_MAFIA)} {config.symbol}
        </Box>
      </Box>
      <Box className={classes.createCostUSD}>
        ${toUSDFormat(mafiaPrice * PROFILE_PRICE_IN_MAFIA, 5)} USD
      </Box>
    </Box>
  );
};
